import axios from 'axios' //导入axios读取接口
import store from '@/store/index.js'

//读取数据接口
var http = (option) => {

	let opt = option ? option : null;

	let opt_default = {
		isLoading: true, //是否加载loading
		isCloseLoading: true, //是否关闭Loading
		loadTitle: '数据加载中',
		url: '', //前缀不用写
		method: 'get', //接口类型
		header: {},
		data: {}, //data参数
		params: {}, //params参数
		dataType: 'json', //数据返回类型
		success: null, //成功回调函数
		successOther: null, //成功回调函数
		error: null, //失败回调函数
		complete: null //调用接口完回调函数
	};
	opt = opt ? Object.assign(opt_default, opt) : opt_default;
	//headerData = headerData ? Object.assign(opt.headerData, headerData) : opt.headerData; //合并header参数
	opt.params.uuid = store.state.uuid
	//alert('加载axios'+JSON.stringify(headerData))
	axios({
		method: opt.method,
		url: store.state.apiUrl + opt.url,
		headers: opt.header,
		data: opt.data,
		params: opt.params
	}).then((res) => {
		//alert('成功code:'+res.data.code)
		if (res.data.status == 200) {
			opt.success && opt.success(res.data);
		} else {
			opt.successOhter && opt.successOhter(res.data);
		}
		opt.complete && opt.complete()
	}).catch((res) => {
		//alert('失败啊啊:'+res)
		opt.error && opt.error(res);
		opt.complete && opt.complete()
	})
}


//输出
export default http



// WEBPACK FOOTER //
// ./src/assets/js/axios.js